import { useMemberProfiles } from 'views/MemberProfile/useMemberProfiles'

export const useMemberProfileSubsTypes = () => {
  const {
    memberMemberProfiles,
    memberMemberProfilesModStatus,
    memberMemberProfilesModErrors,
  } = useMemberProfiles()

  return {
    memberMemberProfiles,
    memberMemberProfilesModStatus,
    memberMemberProfilesModErrors,
  }
}
